export default __webpack_public_path__ + "static/media/nl-selo-180dias.efcb3f8f.webp";